import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserListComponent } from './user-list/user-list.component';
import { AuthGuard } from '../auth-module/auth.guard';
import { UserFormComponent } from './user-form/user-form.component';

const routes: Routes = [
  {
    path: 'user',
    component: UserListComponent,
    canActivate: [AuthGuard],
  }, {
    path: 'user/create',
    component: UserFormComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'user/edit/:id',
    component: UserFormComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'user/view/:id',
    component: UserFormComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
